import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../../messages';
import type { BoxItemEntry } from '../../utils/aggregate-item-positions';
import style from './packing-item-list.module.css';

type PackingItemListProps = {
  items: BoxItemEntry[];
};

export const PackingItemList = ({ items }: PackingItemListProps) => {
  if (!items.length) return null;

  return (
    <ul className={style.itemList}>
      {items.map(({ name, count }) => (
        <li key={name} className={style.itemEntry}>
          <Text textType={TextType.Paragraph} value={messages.itemEntry} formattedMessageValues={{ itemName: name, count }} />
        </li>
      ))}
    </ul>
  );
};
